exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lp-dr-dn[data-v-1947199f]{position:relative}.sel-el[data-v-1947199f]{padding:8px;cursor:pointer}.els[data-v-1947199f]{position:absolute;min-width:56px;width:100%;background:#fff;-webkit-box-shadow:0 4px 4px 1px rgba(0,0,0,.13);box-shadow:0 4px 4px 1px rgba(0,0,0,.13);left:0;z-index:1}.el-item[data-v-1947199f]{width:100%;padding:8px;display:table}.item[data-v-1947199f]:hover{background-color:#eee;cursor:pointer}.el-item div[data-v-1947199f]{display:table-cell;vertical-align:middle}.arrow-down[data-v-1947199f]{color:#787878;width:20px}.outer[data-v-1947199f]{position:fixed;top:0;left:0;right:0;bottom:0}", ""]);

// exports
